<script setup lang="ts">
const { revealAll, toggleAll } = usePrivacyMask();
const { t } = useI18n();

const open = computed(() => revealAll.value);
</script>

<template>
  <v-btn
    icon
    class="custom-hover-primary me-1"
    size="small"
    variant="text"
    rounded="circle"
    :color="open ? 'primary' : undefined"
    :title="open ? t('privacy.hideAll') : t('privacy.showAll')"
    @click="toggleAll"
  >
    <v-icon size="22">{{ open ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
  </v-btn>
</template>
